/*
  Angehefteter Kopf – Hanf & Natur (30.10.2026), Gestaltung in assets/hn-navigation.css
  - Beim Runterscrollen bleibt der angeheftete Kopf weg (Klasse hn-kopf--weg),
    beim Hochscrollen gleitet er wieder herein.
  - Während des Scrollens klappen keine Menüs auf (Klasse hn-scrollt am <html>),
    damit sich nichts öffnet, wenn der Kopf unter dem Mauszeiger hereinkommt.
  theme.js (theme.headerNav) heftet den Kopf ab 250 px an (site-header--stuck); das bleibt unverändert.
*/
(function () {
  var header = document.getElementById('SiteHeader');
  if (!header) return;

  var html = document.documentElement;
  var letzte = window.scrollY;
  var geplant = false;
  var scrollEnde;

  function menueOffen() {
    return html.classList.contains('js-drawer-open') ||
      header.querySelector('.is-focused') !== null;
  }

  function pruefen() {
    geplant = false;
    var y = window.scrollY;
    var diff = y - letzte;

    if (!header.classList.contains('site-header--stuck') || menueOffen()) {
      header.classList.remove('hn-kopf--weg');
    } else if (diff > 4) {
      header.classList.add('hn-kopf--weg');
    } else if (diff < -4) {
      header.classList.remove('hn-kopf--weg');
    }

    if (Math.abs(diff) > 4) {
      letzte = y;
    }
  }

  window.addEventListener('scroll', function () {
    html.classList.add('hn-scrollt');
    clearTimeout(scrollEnde);
    scrollEnde = setTimeout(function () {
      html.classList.remove('hn-scrollt');
    }, 180);

    if (!geplant) {
      geplant = true;
      requestAnimationFrame(pruefen);
    }
  }, { passive: true });
})();
